export default "__VITE_ASSET__B2wWfo_D__"